import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { AddLinkedComponent } from './add-linked.component';
export interface AddLinkedPayload {}
export function addLinkedPayloadParts(): ModalBlockParts {
  return {
    id: 'add-linked-component',
    block: AddLinkedComponent,
    closeBackEnable: false,
    type: ModalType.TYPE1,
    modalWidth: LModalContentsWidthType.MODAL_TAB_W345,
    payload: {} as AddLinkedPayload,
  };
}
